<template>
  <div v-if="
  this.enableAccessAuthCreate('M5', this.getUser.pref.select.fauth) === true">
    <v-btn :color="ui.btnColor" flat dark @click="openDialog()" v-if="data.btnType !== 'icon'">
      <v-icon left>
        add
      </v-icon>
      {{data.btnTitle}}
    </v-btn>
    <v-layout v-else class="text-xs-right">
      <v-btn @click="openDialog()" :color="ui.bkgdColor" icon>
        <v-icon :color="ui.btnColor"> work_history </v-icon>
      </v-btn>
    </v-layout>
    <v-dialog v-model="dialog" :max-width="ui.sizeWidthDialogLarge">
      <v-card :color="ui.bkgdColor">
        <v-card-title :class="ui.textTitle">
          <v-layout row>
            <v-icon large left :color="ui.btnColor"> add </v-icon>
            <span :class="ui.textHeadline">
              <div :class="ui.textColor">
                New Maintenance Plan
              </div>
            </span>
            <v-spacer/>
          </v-layout>
        </v-card-title>
        <v-progress-linear :color="ui.btnColor" height="1" value="100"/>
        <v-card-text :class="ui.bkgdColor">
          <v-layout class="text-xs-left ml-3 mr-2 mt-2">
            <div :class="ui.textSubheading">
              {{localForm.title}}
            </div>
          </v-layout>
          <v-layout class="text-xs-left ml-3 mr-2 mt-2">
            <div :class="ui.textSubheading">
              {{stepInfo.msg}}
            </div>
          </v-layout>
          <v-form v-model="valid" lazy-validation>
            <v-container :class="ui.bkgdColor" v-if="this.step == 0">
              <v-layout row wrap class="ml-2 mr-2">
                <v-flex xs11>
                  <v-text-field
                  v-model="localForm.title"
                  :rules="mustBeLessThanSmall"
                  prepend-icon="work_history"
                  hint="maintenance plan title"
                  persistent-hint
                  required
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="ml-2 mr-2">
                <v-flex xs11>
                  <v-text-field
                  v-model="localForm.id"
                  :rules="mustBeLessThanSmall"
                  prepend-icon="fingerprint"
                  hint="maintenance plan id"
                  persistent-hint
                  required
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2">
                <v-spacer/>
                <v-chip :color="ui.chipColor" :class="ui.textSubheading">
                  <v-icon left :color="ui.btnColor">work_history</v-icon>
                  {{data.info.stats.nm5}}
                </v-chip>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-icon left :color="ui.btnColor"> admin_panel_settings </v-icon>
                  {{data.info.char.driver}}
                </v-chip>
                <v-chip :color="ui.bkgdColor" class="hidden-xs-only">
                  <v-icon left :color="ui.btnColor"> engineering </v-icon>
                  <span :class="ui.textSubheading">
                    {{data.info.char.dis}} | {{data.info.char.owner}}
                  </span>
                </v-chip>
              </v-layout>
            </v-container>

            <v-container :class="ui.bkgdColor" v-if="this.step == 1">
              <v-layout row wrap class="ml-2 mr-2">
                <v-flex xs12 sm6>
                  <v-select
                    v-model="localForm.type"
                    :items="maintPlanTypeOptions"
                    color="wplblue0"
                    prepend-icon="grid_view"
                    hint="plan type"
                    persistent-hint
                  >
                  </v-select>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-select
                    v-model="localForm.itemRisk"
                    :items="escalationOptions"
                    color="wplblue0"
                    prepend-icon="upgrade"
                    hint="escalation"
                    persistent-hint
                  >
                  </v-select>
                </v-flex>
              </v-layout>
              <v-layout class="text-xs-left ml-4 mr-2 mt-4">
                <div :class="ui.textSubheading">
                  Scope and Description
                </div>
              </v-layout>
              <v-layout row wrap class="ml-3 mr-2">
                <v-flex xs12>
                  <v-textarea
                  :color="ui.textColor"
                  :background-color="ui.btnColor"
                  v-model="localForm.des"
                  label="maintenace plan"
                  :disabled="false"
                  :outline="true"
                  :rules="ruleMustBeNotUndefinedANDLessThan2000"
                  hint="reported fault or issue or activity"
                  auto-grow
                  persistent-hint
                  ></v-textarea>
                </v-flex>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2">
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" class="hidden-xs-only">
                  <v-icon left :color="ui.btnColor"> paid </v-icon>
                  <span :class="ui.textSubheading">
                    ${{data.info.char.coste}} {{data.info.char.costu}}
                  </span>
                </v-chip>
                <v-chip :color="ui.bkgdColor" class="hidden-xs-only">
                  <v-icon left :color="ui.btnColor"> co2 </v-icon>
                  <span :class="ui.textSubheading">
                    {{data.info.char.carbe}} {{data.info.char.carbu}}
                  </span>
                </v-chip>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-icon left :color="ui.btnColor"> build_circle </v-icon>
                  <span :class="ui.textSubheading">
                    {{data.info.char.freq}}{{data.info.char.unit}} | {{data.info.char.cond}}
                  </span>
                </v-chip>
              </v-layout>
            </v-container>

            <v-container :class="ui.bkgdColor" v-if="this.step == 2">

              <v-layout class="text-xs-left ml-2 mr-2 hidden-xs-only">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                    <v-icon> work_history </v-icon>
                  </v-avatar>
                  Plan
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  {{localForm.title}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-sm-and-up">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> work_history </v-icon>
                  </v-avatar>
                  {{localForm.title}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-xs-only">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> place </v-icon>
                  </v-avatar>
                  Facility
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  {{getUser.pref.select.fname}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-sm-and-up">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> place </v-icon>
                  </v-avatar>
                  {{getUser.pref.select.fname}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-xs-only">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> grid_view </v-icon>
                  </v-avatar>
                  Type
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  {{localForm.type}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-sm-and-up">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> grid_view </v-icon>
                  </v-avatar>
                  {{localForm.type}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-xs-only">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> error_outline </v-icon>
                  </v-avatar>
                  Risk
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  {{localForm.itemRisk}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-sm-and-up">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> error_outline </v-icon>
                  </v-avatar>
                  {{localForm.itemRisk}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-xs-only">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> fingerprint </v-icon>
                  </v-avatar>
                  ID
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  {{localForm.id}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-sm-and-up">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> fingerprint </v-icon>
                  </v-avatar>
                  {{localForm.id}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> short_text </v-icon>
                  </v-avatar>
                  Description
                </v-chip>
                <v-spacer/>
              </v-layout>
              <v-layout class="text-xs-left ml-4 mr-2 mt-2">
                <div :class="ui.textSubheading">
                  {{localForm.des}}
                </div>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2">
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-icon left :color="ui.btnColor"> admin_panel_settings </v-icon>
                  {{data.info.char.driver}}
                </v-chip>
                <v-chip :color="ui.bkgdColor" class="hidden-xs-only">
                  <v-icon left :color="ui.btnColor"> engineering </v-icon>
                  <span :class="ui.textSubheading">
                    {{data.info.char.dis}} | {{data.info.char.owner}}
                  </span>
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2">
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" class="hidden-xs-only">
                  <v-icon left :color="ui.btnColor"> paid </v-icon>
                  <span :class="ui.textSubheading">
                    ${{data.info.char.coste}} {{data.info.char.costu}}
                  </span>
                </v-chip>
                <v-chip :color="ui.bkgdColor" class="hidden-xs-only">
                  <v-icon left :color="ui.btnColor"> co2 </v-icon>
                  <span :class="ui.textSubheading">
                    {{data.info.char.carbe}} {{data.info.char.carbu}}
                  </span>
                </v-chip>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-icon left :color="ui.btnColor"> build_circle </v-icon>
                  <span :class="ui.textSubheading">
                    {{data.info.char.freq}}{{data.info.char.unit}} | {{data.info.char.cond}}
                  </span>
                </v-chip>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn
          @click="dialog = false" :color="ui.btnColor" flat>
            <v-icon left> exit_to_app </v-icon>
            Close
          </v-btn>
          <v-btn :disabled="!this.step > 0"
          class="hidden-xs-only"
          @click="previousStep(step)" :color="ui.btnColor" flat>
            <v-icon left> navigate_before </v-icon>
            Back
          </v-btn>
          <v-btn :disabled="!this.step > 0"
          class="hidden-sm-and-up"
          @click="previousStep(step)" :color="ui.btnColor" flat>
            <v-icon> navigate_before </v-icon>
          </v-btn>
          <v-spacer/>
          <v-btn :disabled="!valid" v-if="this.step < 4 && this.enableNextBtn"
          @click="nextStep(step)" :color="ui.btnColor" flat
          class="hidden-xs-only">
            Next
            <v-icon right> navigate_next </v-icon>
          </v-btn>
          <v-btn :disabled="!valid" v-if="this.step < 4 && this.enableNextBtn"
          @click="nextStep(step)" :color="ui.btnColor" flat
          class="hidden-sm-and-up"
          >
            <v-icon> navigate_next </v-icon>
          </v-btn>
          <v-btn :disabled="!valid"
          v-if="enableSubmit"
          class="hidden-xs-only"
          @click="createMaintPlan()" :color="ui.colorWarning" flat>
            <v-icon left> add </v-icon>
            Submit
          </v-btn>
          <v-btn :disabled="!valid"
          v-if="enableSubmit"
          class="hidden-sm-and-up"
          @click="createMaintPlan()" :color="ui.colorWarning" flat>
            <v-icon> add </v-icon>
          </v-btn>
          <BtnSpin :btnSpec="btnInfo1" v-if="btnSpinChangeDetail === true"/>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import BtnSpin from "@/frame/animation/components/BtnSpin";
import storeFunctions from "@/data/functions/mixins/storeFunctions.js";
import ruleTextfield from "@/data/rules/mixins/rulesTextfield.js";
import docRevsModFunctions from "@/document/revisions/mixins/docRevsModFunctions.js";
import changeDetail from "@/support/detail/mixins/changeDetail.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import createFirebase from "@/data/cloud/firebase/mixins/createFirebase.js";
import adminFunctions from "@/admin/functions/mixins/adminFunctions.js";
import generateForms from "@/data/functions/mixins/generateForms.js";
import generateID from "@/data/cloud/firebase/mixins/generateID.js";
import relationshipsFunctions from "@/data/functions/mixins/relationshipsFunctions.js";
import workOptions from "@/data/options/mixins/workOptions.js";
import moment from "moment";
import getData from "@/data/cloud/firebase/mixins/getData.js";
import transFunctions from "@/support/transitions/mixins/transFunctions.js";
import escalationOptions from "@/data/options/mixins/escalationOptions.js";
import numberFunctions from "@/data/functions/mixins/numberFunctions.js";
import describeDocument from "@/data/describe/mixins/describeDocument";
import maintOptions from "@/data/options/mixins/maintOptions.js";
import listFunctions from "@/data/functions/mixins/listFunctions.js";
import { mapGetters } from "vuex";

export default {
  components: {
    BtnSpin
    // OriginalData
  },
  // eslint-disable-next-line
  mixins: [
    getData,
    apptheme,
    adminFunctions,
    docRevsModFunctions,
    createFirebase,
    ruleTextfield,
    workOptions,
    storeFunctions,
    changeDetail,
    relationshipsFunctions,
    generateID,
    generateForms,
    transFunctions,
    describeDocument,
    escalationOptions,
    maintOptions,
    listFunctions,
    numberFunctions
  ],
  props: {
    data: {
      type: Object
    }
  },
  beforeMount() {
    if (this.getOriginal !== null && this.getOriginal !== undefined) {
      this.localForm.title = this.getOriginal.basic.title;
    }
  },
  data() {
    return {
      dialog: false,
      btnSpinChangeDetail: false,
      valid: true,
      btnInfo1: {
        color: "red",
        icon: "person",
        name: "add user"
      },
      indeterminateProgressBar: false,
      step: 0,
      localForm: {
        title: "",
        id: "",
        des: "",
        type: "",
        itemRisk: ""
      },
      info: [
        {
          step: 0,
          title: "Maintenance Plan",
          // eslint-disable-next-line
          msg: "Maintenance Plan is a multi asset maintenance execution program with predefined execution plan and resources. Maintenance Plan must have approved  Maintenance Strategy and Maintenance Activity.",
          icon: ""
        },
        {
          step: 1,
          // eslint-disable-next-line
          title: "Maintenance Plan.",
          // eslint-disable-next-line
          msg: "Maintenance Plan scope is specific to the facility or asset requirements. The procedure,  inspection and test plan must be specific to the facility, considering system impacts and safety execution hazards.",
          icon: ""
        },
        {
          step: 2,
          // eslint-disable-next-line
          title: "Maintenance Plan.",
          // eslint-disable-next-line
          msg: "Verify and submit the Maintenance Plan. Maintenance Activity will be incorporated in the Maintenance Plan. Facility specific Maintenance Plan  approval process will be completed by different business processes which consider technical and business risks.",
          error: "",
          icon: ""
        }
      ]
    };
  },
  computed: {
    // eslint-disable-next-line
    ...mapGetters([
      "getUser",
      "getCurrentPage",
      "getOriginal",
      "getDetail",
      "getDetailStats",
      "getMaintActivityList",
      "getMaintActivityListCounter"
    ]),
    ui() {
      return this.uiTheme1;
    },
    stepInfo() {
      return this.info[this.step];
    },
    enableSubmit() {
      let logic = false;
      if (this.step === 2 && this.btnSpinChangeDetail === false) {
        logic = true;
      } else if (this.btnSpinChangeDetail === true) {
        logic = false;
      } else {
        logic = false;
      }
      return logic;
    },
    enableNextBtn() {
      let logic = false;
      if (
        this.step == 0 &&
        this.localForm.title !== "" &&
        this.localForm.id !== ""
      ) {
        logic = true;
      } else if (
        this.step == 1 &&
        this.localForm.type !== "" &&
        this.localForm.des !== ""
      ) {
        logic = true;
      } else {
        logic = false;
      }
      return logic;
    }
  },
  methods: {
    nextStep(step) {
      this.step = step + 1;
    },
    previousStep(step) {
      this.step = step - 1;
    },
    openDialog() {
      this.dialog = true;
      this.step = 0;
      this.btnSpinReadResult = false;
      // let ctr = this.data.info.stats.nm5 + 1;
      // let ctr = this.getDetailStats.nm7 + 1;
      // GENERATE TITLE
      let title = this.data.info.char.freq + this.data.info.char.unit;
      title = title + " " + this.data.info.basic.title;
      this.localForm.title = title;
      // GENERATE ID
      let id = this.generateMaintPlanIDfromMaintActivity(
        this.getDetailBasic.tag,
        this.getDetailBasic.idg,
        this.data.info.basic.idi,
        this.data.info.stats.nm5
      );
      // let idg = this.generateIDG("date-gid");
      // let id = this.displayDocumentIDGTypeA("M5", idg)
      this.localForm.id = id;
      this.localForm.des = this.data.info.char.com;
      this.localForm.type = "Area";
      this.localForm.itemRisk = "Fault";
    },
    closeDialog() {
      this.btnSpinReadResult = false;
    },
    refreshMaintActivityList() {
      let store = "changeMaintActivityListCounter";
      // counter +1 and -1, needed to refresh the list
      this.$store.dispatch(store, this.getMaintActivityListCounter + 1);
      this.$store.dispatch(store, this.getMaintActivityListCounter - 1);
      this.$store.dispatch("changeDataSavePendingIndication", true);
      this.saveDocumentRevMod(5.12, 1); // maintActivity removed.
    },
    createMaintPlan() {
      this.btnSpinChangeDetail = true;
      // SET data source
      const tag = "M5";
      const did = this.generateDID("DATE", tag);
      const idg = this.generateIDG("date-gid");

      // GENERATE form
      let temp = this.generateMaintPlanForm(); // form is from compnew component

      // ASSIGN data
      temp.basic.did = did;
      temp.basic.idg = idg;
      temp.basic.tag = tag;
      temp.basic.act = true; // set to true
      temp.basic.title = this.localForm.title;
      temp.basic.id = this.localForm.id;

      temp.char.scope = this.localForm.des;
      temp.char.type = this.localForm.type;
      temp.char.escal = this.localForm.itemRisk;
      temp.char.comp = this.data.info.char.comp;
      temp.char.pri = "P5";
      temp.stats.dcrt = moment().format();

      // REV
      temp.rev = this.generateInitialDocumentRev(tag);

      // RELPS
      // let relps = this.generateInitialRelationships(tag);
      // temp.relps = relps;

      // TRANS
      let trans = this.generateInitalTransition(tag); // model
      temp.trans = trans;

      // let trans = this.generateInitalTrans("AMP"); // model
      // temp.trans = trans;

      // LINK (Update Maint Strategy)
      temp.link.msdid = this.getDetail.basic.did;
      temp.link.msid = this.getDetail.basic.id;
      temp.link.msidg = this.getDetail.basic.idg;
      temp.link.mst = this.getDetail.basic.title;
      // LINK (Update Maint Strategy)
      temp.link.madid = this.data.info.basic.did;
      temp.link.maid = this.data.info.basic.id;
      temp.link.maidg = this.data.info.basic.idg;
      temp.link.mat = this.data.info.basic.title;

      // STRATEGY
      temp.strategy = this.data.info;
      // Update
      this.saveDocumentRevMod(5.11, 1); // attachment added.

      // HELP
      console.log("NEW MAINT PLAN");
      console.log(temp);

      // UPDATE MAINT ACTIVITY COUNTER for Startegy
      let maintStrategyStats = this.getDetailStats;
      maintStrategyStats.nm5 = maintStrategyStats.nm5 + 1;
      this.$store.dispatch("changeDetailStats", maintStrategyStats);

      // UPDATE MAINT ACTIVITY COUNTER for Maint Activity
      var tempList = this.getMaintActivityList;
      var tempForm = this.data.info;
      tempForm.stats.nm5 = tempForm.stats.nm5 + 1;
      var obj = Object.assign({}, tempForm);
      var parseobj = JSON.parse(JSON.stringify(obj));
      var newList = this.changeItemReturnList(parseobj, tempList);
      this.$store.dispatch("changeMaintActivityList", newList);
      this.refreshMaintActivityList();

      // Update MS to capture counters for Maint Actvity
      this.changeDetail();

      // Create Noti
      this.createFirebaseDocumentOnly(temp);
    }
  }
};
</script>
